import { LogRepository } from "@domain/repositories/LogRepository";
import UseCase from "@domain/UseCase";
import { Log } from "@domain/models/Log";
import { Route } from "@domain/models/Route";

type Input = Route["id"];

type Output = Promise<Log[]>;

export class GetRouteLogsUseCase implements UseCase<Input, Output> {
  constructor(private readonly logRepository: LogRepository) {}

  execute(routeId: Input) {
    return this.logRepository.getRouteLogs(routeId);
  }
}
